window.addEventListener('load', function () {
  const timer = setInterval(() => {
    if (document.getElementsByTagName) {
      const inputElements = document.getElementsByTagName('input')

      for (let i = 0; inputElements[i]; i++) {
        inputElements[i].setAttribute('autocomplete', 'off')
      }
    }

    clearInterval(timer)
  }, 1000)
})
